<template>
  <div class="page-wapper fb fb-col" :style="popStyle">
    <div class="page-content item-flex-1 fb fb-col" @click="emitChange">
      <div class="pop-con font-34 ff-regular c-171A1D text-bold-400">
        <div class="class-cascader fb">
          <div class="grade-list item-flex-2">
            <div
              class="grade-list-item"
              v-for="grade in deptList"
              :class="{
                active:
                  `${grade.gradeDingId}` === `${curGradeAndClass.gradeDingId}`
              }"
              @click.stop="handlerGrade(grade)"
              :key="grade.gradeDingId"
            >
              {{ grade.gradeName }}
            </div>
          </div>
          <!--   @click.stop="fetchTimeTable(cls.classDingId, cls.className)" -->
          <div class="class-list item-flex-3">
            <div
              class="class-list-item"
              v-for="cls in gradeClassList"
              :class="{
                active:
                  `${cls.classDingId}` === `${curGradeAndClass.classDingId}`
              }"
              :key="cls.classDingId"
              @click.stop="handlerClass(cls)"
            >
              {{ cls.className }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonGradeAndClass',
  props: {
    deptList: {
      type: Array,
      default: () => []
    },
    top: {
      type: Number,
      default: 0
    },
    defaultDept: {
      type: Object,
      default: () => {
        return {
          gradeDingId: '',
          gradeName: '',
          classDingId: '',
          className: ''
        }
      }
    }
  },
  data() {
    return {
      curGrade: {
        gradeDingId: '',
        gradeName: ''
      },
      curClass: {
        classDingId: '',
        className: ''
      }
    }
  },
  watch: {
    defaultDept: {
      // eslint-disable-next-line space-before-function-paren
      handler: function () {
        this.fixDefaultDeptData()
      },
      deep: true,
      immediate: true
    },
    deptList: {
      // eslint-disable-next-line space-before-function-paren
      handler: function () {
        this.fixDefaultDeptData()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    curGradeAndClass() {
      return {
        ...this.curGrade,
        ...this.curClass
      }
    },
    popStyle() {
      return {
        top: this.top + 'px'
      }
    },
    gradeClassList() {
      let _gradeDingId = String(this.curGradeAndClass.gradeDingId)
      if (!_gradeDingId) {
        return []
      }
      let _filterList = this.deptList.filter(
        item => String(item.gradeDingId) === _gradeDingId
      )
      if (_filterList.length) {
        return _filterList[0].classSimpleList || []
      }
      return []
    }
  },
  methods: {
    fixDefaultDeptData(newVal) {
      let { gradeDingId, classDingId } = this.defaultDept || {}

      if (gradeDingId) {
        this.curGrade = {
          ...this.curGrade,
          gradeDingId
        }
      }
      if (classDingId) {
        this.curClass = {
          ...this.curClass,
          classDingId
        }
        // 处理只传 ID 名字回显问题
        let _filterList = this.gradeClassList.filter(
          item => item.classDingId === this.curClass.classDingId
        )
        if (_filterList.length) {
          this.curClass = {
            ...this.curClass,
            ...(_filterList[0] || {})
          }
        }
      }
    },
    handlerGrade({ gradeDingId, gradeName }) {
      this.curGrade = {
        gradeDingId,
        gradeName
      }
    },
    handlerClass({ classDingId, className }) {
      this.curClass = {
        classDingId,
        className
      }
      this.emitChange()
    },
    emitChange() {
      this.$emit('change', this.curGrade, this.curClass)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  .page-header {
    background-color: #fff;
    .header-tab {
      .tab-list-item {
        position: relative;
        text-align: center;
        line-height: 20px;
        color: rgba(23, 26, 29, 0.6);
        &_active {
          @extend .tab-list-item;
          color: #171a1d;
          &::after {
            content: ' ';
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -6px;
            background: #171a1d;
            width: 20px;
            height: 3px;
          }
        }
      }
    }
  }
  .page-content {
    position: relative;
    overflow: hidden;
    .dept-box {
      max-width: 120px;
    }
    .pop-con {
      position: absolute;
      z-index: 29;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(23, 26, 29, 0.28);
      &::before {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: rgba(25, 31, 37, 0.08);
        content: ' ';
      }
      .class-cascader,
      .teacher-cascader {
        background: #fff;
        width: 100%;
        text-align: left;
        .grade-list,
        .course-list {
          background: #ebebeb;
          max-height: 360px;
          overflow: auto;
          &-item {
            padding: 16px 16px 16px 16px;
            word-wrap: break-word;
            &.active {
              background: #fff;
            }
          }
        }
        .class-list,
        .teacher-list {
          max-height: 360px;
          overflow: auto;
          &-item {
            padding: 16px 16px 16px 24px;
            word-wrap: break-word;
            position: relative;
            &.active:before {
              position: absolute;
              left: 4px;
              top: 50%;
              transform: translateY(-50%);
              font-family: 'iconfont';
              content: '\e632';
              color: #006afe;
            }
          }
        }
      }
    }
    .timetable {
      position: relative;
      background: #fff;
      overflow: auto;
      -webkit-overflow-scrolling: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .timetable-day {
        position: sticky;
        top: 0;
        z-index: 20;
        > div {
          background: #e1e1e6;
          border-right: 1px solid rgba(126, 134, 142, 0.16);
          // &:last-child {
          //   border-right: none;
          // }
        }
        .week-index {
          position: sticky;
          top: 0;
          left: 0;
          bottom: 0;
          z-index: 21;
          > div {
            width: 20px;
          }
        }
        .week-day {
          line-height: 1.2;
          padding: 12px 0;
          flex: 0 0 calc(20% - 4px);
          box-sizing: border-box;
        }
      }
      .timetable-data {
        .classname {
          line-height: 16px;
        }
        .data-row {
          text-align: center;
          position: relative;
          &:last-child {
            .data-item {
              border-bottom: 1px solid rgba(126, 134, 142, 0.16);
            }
          }
          > div {
            border-top: 1px solid rgba(126, 134, 142, 0.16);
            border-right: 1px solid rgba(126, 134, 142, 0.16);
            // &:last-child {
            //   border-right: none;
            // }
          }
          .data-index {
            background: #e1e1e6;
            position: sticky;
            left: 0;
            z-index: 19;
            .row-index {
              width: 20px;
            }
          }
          .data-item {
            line-height: 1.2;
            padding: 4px;
            height: 76px;
            background: #fff;
            flex: 0 0 calc(20% - 4px);
            box-sizing: border-box;
            > div {
              min-height: 19px;
              padding-top: 3px;
              &:last-child {
                color: rgba(23, 26, 29, 0.6);
              }
            }
          }
        }
      }
    }
  }
}
</style>
